"use client";
import { Api } from "@/Apis";
import { LandingSelectGetCenterProductsInputApiModel } from "@/Apis/ClinicApi";
import { Helper } from "@/Helpers";
import { selectProps } from "@/Helpers/Constants";
import { useDeepCompareEffectDebounce } from "@ant-design/pro-components";
import { Select, SelectProps } from "antd";
import { FC, useState } from "react";

export interface LandingCenterProductsSelectProps
  extends SelectProps, LandingSelectGetCenterProductsInputApiModel {
  autoSelectFirstOption?: boolean;
}

const LandingCenterProductsSelect: FC<LandingCenterProductsSelectProps> = ({
  autoSelectFirstOption,
  CenterId,
  CenterItemId,
  ...props
}) => {
  const model: LandingSelectGetCenterProductsInputApiModel = {
    CenterId,
    CenterItemId,
  };
  useDeepCompareEffectDebounce(
    () => {
      getOptions();
    },
    [model],
    [],
    1000,
  );

  const [options, setOptions] = useState<any[]>();
  const [loading, setLoading] = useState(true);
  const getOptions = async () => {
    setLoading(true);
    const { Result } = await Api.LandingSelect.getCenterProducts(model);
    const options = Helper.arrayToOptions(Result);
    setOptions(options);
    if (autoSelectFirstOption && options.length > 0)
      props.onChange?.(options[0].value, options[0]);
    setLoading(false);
  };
  return (
    <Select
      options={options}
      loading={loading}
      {...selectProps}
      {...(props as any)}
      value={
        options?.map((p) => p.value).includes(props.value)
          ? props.value
          : undefined
      }
    />
  );
};

export default LandingCenterProductsSelect;
